import { cn } from '@/utils/cn';

const REQUIRED_SUFFIX = ' *';

/** Strip a trailing " *" from legacy labels and treat it as required. */
export function parseFieldLabel(label: string | undefined, required?: boolean) {
  if (!label) {
    return { text: undefined as string | undefined, required: Boolean(required) };
  }
  if (label.endsWith(REQUIRED_SUFFIX)) {
    return {
      text: label.slice(0, -REQUIRED_SUFFIX.length),
      required: true,
    };
  }
  return { text: label, required: Boolean(required) };
}

export interface FieldLabelProps {
  htmlFor?: string;
  label?: string;
  required?: boolean;
  className?: string;
}

/** Standard form label with a red asterisk for required fields. */
export function FieldLabel({ htmlFor, label, required, className }: FieldLabelProps) {
  const parsed = parseFieldLabel(label, required);
  if (!parsed.text) return null;

  return (
    <label htmlFor={htmlFor} className={cn('label', className)}>
      {parsed.text}
      {parsed.required && <span className="text-red-600 dark:text-red-400"> *</span>}
    </label>
  );
}
